<script>
import ApeUploader from '@/components/ApeUploader'

export default {
  components: {
    ApeUploader
  },
  data() {
    return {
      centerDialogVisible: false,
      dialogTitle: '添加分类',
      // 表单结构
      formData: {},
      // 已上传文件列表
      uploadFileList: [],
      // 表单验证
      rules: {
        display_name: [{ required: true, message: '输入分类名称', trigger: 'change' }],
        name: [{ required: true, message: '输入分类标识', trigger: 'change' }]
      }
    }
  },
  methods: {
    show() {
      this.centerDialogVisible = true
    },
    add(row) {
      this.show()
      this.formData = { parent_id: 0, name: '', display_name: '', url: '', additional: '', remark: '', image_url: null,order:100 }
      const pid = row.id ? row.id : 0
      if (pid > 0) {
        this.dialogTitle = '添加子分类'
        this.formData.name = `${row.name}_`
      } else {
        this.dialogTitle = '添加分类'
      }

      this.formData.parent_id = pid
    },
    async edit(row) {
      this.show()
      const id = row.id
      this.dialogTitle = '编辑分类'
      const { info } = await this.$api.getCategoryInfo(id)
      this.formData = info || {}
      this.uploadFileList = info.image_info.id ? [{
        id: info.image_info.id,
        name: info.image_info.title,
        url: info.image_info.full_path
      }] : []
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.image = file.id
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.image = 0
      this.uploadFileList = fileList
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['categoryForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    //添加,保存
    async formSubmit() {
      const id = await this.$api.saveCategory(this.formData)
      if (id && id > 0) {
        this.$message.success('保存成功')
        this.centerDialogVisible = false
        this.$emit('saved')
        // setTimeout(() => {
        // let ids = this.$refs['treeTable'].getExpandIds()
        //   this.handleRefresh(ids)
        // }, 100)

      }
    }
  }
}
</script>

<template>
  <el-dialog
    :title='dialogTitle'
    :visible.sync='centerDialogVisible'
    width='50%'
    center>
    <el-form :model='formData' :rules='rules' ref='categoryForm' label-position='right' label-width='96px'>
      <el-form-item label='分类名称' prop='display_name'>
        <el-input v-model='formData.display_name' clearable></el-input>
      </el-form-item>
      <el-form-item label='分类标识' prop='name'>
        <el-input v-model='formData.name' placeholder='分类标识' clearable></el-input>
      </el-form-item>
      <el-form-item label='排序值' prop='additional'>
        <el-input type='number' v-model='formData.order' placeholder='排序值越小排越靠前' clearable></el-input>
      </el-form-item>
      <el-form-item label='跳转链接' prop='url'>
        <el-input v-model='formData.url' clearable></el-input>
      </el-form-item>
      <el-form-item label='附加内容' prop='additional'>
        <el-input type='textarea' v-model='formData.additional' clearable></el-input>
      </el-form-item>
      <el-form-item label='备注' prop='description'>
        <el-input type='textarea' v-model='formData.description' clearable></el-input>
      </el-form-item>
      <el-form-item label='图片' prop='image' ref='imageItem'>
        <ApeUploader :limit='1' @handleUploadSuccess='handleUploadSuccess' @handleUploadRemove='handleUploadRemove'
                     :upload-file-list='uploadFileList'></ApeUploader>
      </el-form-item>

    </el-form>
    <span slot='footer' class='dialog-footer'>
      <el-button @click='centerDialogVisible = false'>取 消</el-button>
      <el-button type='primary' @click='handleConfirm()'>确 定</el-button>
    </span>
  </el-dialog>
</template>

<style scoped>

</style>
